const backendEs = {
  auth_not_authenticated: 'Inicia sesión para continuar.',
  auth_permission_denied_add_org: 'No tienes permiso para añadir una organización.',
  payload_missing_required_fields: 'Faltan algunos datos obligatorios.',
  organisation_invalid_type: 'El tipo de organización no es válido.',
  organisation_duplicate_owner_name: 'Ya existe una organización con este nombre.',
  organisation_create_failed: 'No pudimos crear la organización.',
  organisation_set_claims_failed_owner: 'No pudimos actualizar los permisos del propietario.',
  organisation_set_claims_failed_user: 'No pudimos actualizar los permisos del usuario.',
  organisation_add_failed: 'No pudimos añadir la organización.',
  organisation_not_found: 'No pudimos encontrar esa organización.',
  organisation_missing_fields: 'A la organización le falta información obligatoria.',
  onboarding_not_new_user: 'Esta cuenta ya completó el proceso de incorporación.',
  onboarding_unknown_error: 'Se produjo un error al finalizar la incorporación.',
  email_invalid_argument: 'Introduce una dirección de correo válida.',
  email_already_verified: 'Este correo ya está verificado.',
  email_no_data: 'No pudimos preparar el correo de verificación.',
  email_sending_failed: 'No pudimos enviar el correo. Inténtalo más tarde.',
  email_verification_failed: 'No pudimos enviar un nuevo correo de verificación.',
  promoter_not_found: 'No pudimos encontrar a ese promotor.',
  promoter_missing_claims: 'El perfil del promotor está incompleto.',
  password_strength_failed: 'Elige una contraseña más segura que cumpla todos los requisitos.',
  invitation_invalid_token: 'Tu enlace de invitación no es válido o ha caducado. Abre el correo de invitación más reciente.',
  invitation_not_found: 'No pudimos encontrar esa invitación.',
  invitation_not_pending: 'Esta invitación ya no está pendiente.',
  invitation_missing_id: 'Falta la referencia de la invitación.',
  invitation_public_cancel_denied: 'Las invitaciones públicas no se pueden cancelar.',
  invitation_not_inviter: 'Solo la persona que invitó puede gestionar esta invitación.',
  invitation_not_inviter_or_delegate: 'Solo la persona que invitó o su delegado puede gestionar esta invitación.',
  invitation_promoter_not_public: 'Este promotor no acepta invitaciones públicas.',
  invitation_invalid_email_format: 'Introduce un correo y una contraseña válidos.',
  invitation_invalid_role_division: 'El rol o la división seleccionada no está permitida.',
  invitation_already_accepted: 'Esta persona ya aceptó una invitación.',
  invitation_email_in_use: 'Este correo ya está registrado.',
  invitation_create_failed: 'No pudimos crear la invitación.',
  invitation_create_user_failed: 'No pudimos crear la cuenta de usuario.',
  invitation_create_user_ref_failed: 'No pudimos vincular la cuenta de usuario.',
  invitation_inviter_data_failed: 'No pudimos cargar la información de quien invita.',
  invitation_inviter_claims_failed: 'No pudimos cargar los permisos de quien invita.',
  invitation_custom_claims_too_large: 'Los permisos de la invitación son demasiado extensos.',
  invitation_invite_permission_denied: 'No tienes permiso para invitar a alguien.',
  invitation_fetch_failed: 'No pudimos cargar las invitaciones.',
  invitation_user_missing_email: 'Tu cuenta necesita una dirección de correo.',
  invitation_owner_missing: 'No pudimos encontrar al propietario del promotor.',
  invitation_role_not_authorized: 'Este rol no está autorizado para invitaciones.',
  invitation_role_not_found: 'No pudimos encontrar ese rol.',
  invitation_pending_exists: 'Ya hay una invitación en curso para esta persona.',
  invitation_cancel_unknown: 'No pudimos cancelar la invitación.',
  invitation_reject_unknown: 'No pudimos rechazar la invitación.',
  invitation_request_unknown: 'No pudimos enviar la solicitud de invitación.',
  verify_email_unknown: 'No pudimos verificar el correo.',
  superuser_unauthorized: 'Solo los superusuarios pueden realizar esta acción.',
  superuser_invitations_unknown: 'No pudimos cargar la lista de invitaciones.',
  superuser_users_unknown: 'No pudimos cargar la lista de usuarios.',
  superuser_organisations_unknown: 'No pudimos cargar la lista de organizaciones.',
  signup_requires_auth: 'Inicia sesión para continuar.',
  signup_unknown_error: 'Se produjo un error al crear la cuenta.',
  signup_update_password_failed: 'No pudimos actualizar la contraseña.',
  provider_already_exists: 'Este proveedor ya existe.',
  custom_claims_set_failed: 'No pudimos actualizar los permisos de la cuenta.',
} as const;

export default backendEs;
